import $ from 'jquery';
import { Popup } from 'leaflet/src/layer/Popup';
import { Rectangle } from 'leaflet/src/layer/vector/Rectangle';
import { ImageOverlay } from 'leaflet/src/layer/ImageOverlay';
import { Polyline } from 'leaflet/src/layer/vector/Polyline';
import log from 'log';
import * as i18n from 'i18n-setup';
import * as Overlay from 'overlay';
import * as Doc from 'doc';
import style from 'style';
import state from 'state';

var $window = $(window);

export function activate() {
    function annotate(e) {
        e.preventDefault();
        submit[0].disabled = true;
        var params = {
            page: state.page,
            x: coord.lng,
            y: coord.lat,
            title: title.val(),
            text: text.val()
        };
        log(params); //TODO: debug
        $.postJSON(state.base + 'annotate', params
        ).then(function (data) {
            if ('error' in data) {
                Overlay.error(i18n.str('annot.error') + ':\n' + data.error);
                return;
            }
            state.pdf.triggerSafe('annotated', [ data ]);
            state.map.closePopup();
            Doc.updateFiles(data);
        }).catch(function () {
            Overlay.error(i18n.str('err.contact'));
        }).always(function () {
            submit[0].disabled = false;
        });
    }
    function placeAnnotation(e) {
        var width = $window.width(),
            opt = {};
        if (width < 400)
            opt.maxWidth = width - 50;
        title.val('');
        text.val('');
        coord = e.latlng;
        state.map.openPopup(new Popup(opt).setLatLng(coord).setContent(form[0]));
    }
    function clickAndAnnotate(e) {
        e.preventDefault();
        state.panel.annot.close();
        //TODO: avvertire l'utente
        state.map.once('click', placeAnnotation);
    }
    function placeDoodle(e) {
        e.preventDefault();
        state.panel.annot.close();
        state.doodle.get(function (strokes) {
            if (!strokes)
                return; // it was canceled
            $.postJSON(state.base + 'doodle', {
                page : (state.page + 1), //TODO: keep +1 server-side
                strokes : JSON.stringify(strokes)
            }).then(function (data) {
                Doc.updateFiles(data);
            }).catch(function () {
                //TODO error alert
            });
        });
    }
    var cont = $('.content', state.panel.annot),
        form = $('<form/>'),
        title = $('<input type="text"/>'),
        text = $('<textarea/>').attr({
            cols: 30,
            rows: 4
        }),
        submit = $('<input type="submit"/>').i18n('annot.button.create'),
        coord;
    $('<h3/>').i18n('annot.create').appendTo(form);
    form.append($('<span/>').i18n('annot.title')).append(' ').append(title);
    text.appendTo(form);
    submit.appendTo(form);
    form.submit(annotate);
    // add create button
    if (state.feature.annotation !== false)
        $('<a/>').i18n('annot.create').attr('href', '#').click(clickAndAnnotate).appendTo(cont);
    if (state.feature.doodle !== false)
        $('<a/>').i18n('annot.doodle.create').attr('href', '#').click(placeDoodle).appendTo(cont);
}

function highlightAnnotations(annot) {
    function remove(a, d) {
        if (a.ref)
            $('<a/>').attr({ href: 'delete annotation' }).i18n('annot.delete').click(function (e) {
                e.preventDefault();
                $.postJSON(state.base + 'rmannot', {
                    page: (state.page + 1), //TODO: keep +1 server side
                    ref: a.ref
                }).then(function (data) {
                    if ('error' in data) {
                        Overlay.error(i18n.str('annot.error') + ':\n' + data.error);
                        return;
                    }
                    Doc.updateFiles(data);
                }).catch(function () {
                    Overlay.error(i18n.str('annot.error') + '.');
                });
            }).appendTo(d);
    }
    function showLink(a) {
        var d = $('<div/>');
        $('<h3/>').text('External link').appendTo(d);
        $('<a/>').attr({ href: a.link.uri, target: '_blank' }).text(a.link.uri).appendTo(d);
        remove(a, d);
        return d[0];
    }
    function showNote(a) {
        var d = $('<div/>');
        $('<h3/>').text(a.title).appendTo(d);
        $('<textarea/>').attr({ cols: 30, rows: 4 }).text(a.text).prop('readonly', true).appendTo(d);
        remove(a, d);
        return d[0];
    }
    function removePointerEvents() { // should click through even if the image covers the rectangle
        //jshint validthis: true
        this._image.style.pointerEvents = 'none';
    }
    function triggerPopup(r) {
        return function (e) {
            e.preventDefault();
            state.panel.annot.close();
            r.openPopup();
        };
    }
    var list = $('ol', state.panel.annot),
        opt = Doc.popupOpts();
    list.empty();
    Doc.layer.annot.clearLayers();
    for (var i = 0; i < annot.length; ++i) {
        var a = annot[i],
            c = Doc.convertPos(a.position),
            r = new Rectangle(c, style.annot);
        if ('text' in a) {
            var img = new ImageOverlay('images/balloon.png', c);
            img.on('load', removePointerEvents); //TODO: remove this dirty hack
            Doc.layer.annot.addLayer(img);
            r.bindPopup(showNote(a), opt);
            $('<li/>').append(
                $('<a/>').text(a.title).attr('href', '#note' + i).click(triggerPopup(r))
            ).appendTo(list);
        } else if ('poly' in a)
            r = new Polyline(Doc.convertPosArray(a.poly), style.doodle);
        else if (!('link' in a))
            ; // nothing to do here
        else if ('page' in a.link)
            r.on('click', Doc.changePage.bind(null, a.link.page));
        else if ('uri' in a.link)
            r.bindPopup(showLink(a), opt);
        Doc.layer.annot.addLayer(r);
    }
}

export function load(p) {
    if (state.feature.annotation === false && state.feature.doodle === false)
        return;
    $.getJSON(state.base + 'page_' + p + '.json'
    ).then(function (data) {
        if (p != state.page)
            return; // page was changed during the AJAX call
        if ('annotations' in data)
            highlightAnnotations(data.annotations);
        else
            Overlay.error('Format error in document annotations.');
    }).catch(function () {
        Overlay.error('Error getting document annotations.');
    });
}
